export default "__VITE_ASSET__eec8a119__"